module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_c('navbar'), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("peakflowmeter")))])]), _vm._v(" "), _c('md-card-content', [_c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t("peakflowmeterinfo"))), _c('br'), _c('br'), _vm._v("\n\n\t\t\t\t\t" + _vm._s(_vm.$t("peakflowmeterlink")) + " "), _c('a', {
    attrs: {
      "href": "http://www.webbeteg.hu/cikkek/asztma/289/hogyan-diagnosztizaljak-az-asztmat"
    }
  }, [_vm._v("http://www.webbeteg.hu/cikkek/asztma/289/hogyan-diagnosztizaljak-az-asztmat")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "320",
      "height": "200",
      "src": "https://www.youtube.com/embed/2gwGmyBdq_o",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bc35bd0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoView.vue
// module id = 411
// module chunks = 2